import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface MembershipCode {
  id?: string;
  organization: string;
  code: string;
  expiresOn: Date;
  isUsed: boolean;
  valid: boolean;
  createdAt: Date;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MembershipCodesService {
  private apiUrl = environment.apiUrl + '/membership-codes';

  constructor(private http: HttpClient) { }

  getAllCodes(): Observable<MembershipCode[]> {
    return this.http.get<MembershipCode[]>(this.apiUrl);
  }

  createCode(code: MembershipCode): Observable<MembershipCode> {
    return this.http.post<MembershipCode>(this.apiUrl, code);
  }

  updateCode(id: string, code: MembershipCode): Observable<MembershipCode> {
    return this.http.put<MembershipCode>(`${this.apiUrl}/${id}`, code);
  }

  deleteCode(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
} 